
import Vue from 'vue'

export default Vue.extend({
    name: 'Contact',
    components: {},
    computed: {
        typeFormUrl() {
            return process.env.VUE_APP_TYPEFORM_URL;
        },
        whatsAppUrl() {
            return process.env.VUE_APP_CES_WHATSAPP_URL;
        },
    },
    data() {
        return {}
    },
    methods: {
        
    }
})
